import React from 'react';

const SampleNote = ({ note }) => (
  <div className="home-paper relative border border-[#17211E]/15 p-7 text-[#17211E] sm:p-10">
    <div className="absolute -right-3 -top-3 h-8 w-8 border-r-2 border-t-2 border-[#D7B77A]" />
    <div className="mb-8 flex items-start justify-between border-b border-[#17211E]/15 pb-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-[#174C3C]">
          {note.eyebrow}
        </div>
        <div className="mt-2 home-serif text-2xl text-[#17211E]">
          {note.title}
        </div>
      </div>
      <div className="text-right text-xs font-bold uppercase tracking-wider text-[#17211E]/45 whitespace-pre-line">
        {note.office}
      </div>
    </div>
    <div className="space-y-5">
      {note.items.map((item) => (
        <div key={item.name}>
          <div className="flex items-center justify-between gap-4">
            <span className="font-bold">{item.name}</span>
            {item.status && (
              <span className="text-sm font-semibold text-[#174C3C]">
                {item.status}
              </span>
            )}
          </div>
          <div className="mt-3 home-report-line" />
          <p className="mt-2 text-sm text-[#17211E]/65">{item.detail}</p>
        </div>
      ))}
    </div>
    <div className="mt-9 border-t border-[#17211E]/15 pt-5 text-sm italic text-[#17211E]/60">
      {note.footer}
    </div>
  </div>
);

export default SampleNote;
